import { render, staticRenderFns } from "./tobacco_jimo_inspection_record_page.vue?vue&type=template&id=160c753c&scoped=true"
import script from "./tobacco_jimo_inspection_record_page.vue?vue&type=script&lang=js"
export * from "./tobacco_jimo_inspection_record_page.vue?vue&type=script&lang=js"
import style0 from "./tobacco_jimo_inspection_record_page.vue?vue&type=style&index=0&id=160c753c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160c753c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('160c753c')) {
      api.createRecord('160c753c', component.options)
    } else {
      api.reload('160c753c', component.options)
    }
    module.hot.accept("./tobacco_jimo_inspection_record_page.vue?vue&type=template&id=160c753c&scoped=true", function () {
      api.rerender('160c753c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tobacco_jimo/tobacco_jimo_inspection_record_page.vue"
export default component.exports